import * as React from "react"
import {Grid} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import {LabelCountry} from "@components";
import {PriceEvolutionBaseWidget} from "../../@components";
import { priceEvolutionWidgetFormatPrice } from "../../@utils";


export default function PriceEvolutionWidgetRetailerBlock({ data, isPercentage, useListPrice, dataMinMax={}, disableMinMax=false, ...props }) {

	return data.map((d, idx) => {
		const value = useListPrice ? d.listKPI : d.actualKPI
		const numVariants = d.numVariants
		const prevValue = useListPrice ? d.listPrevKPI : d.actualPrevKPI
		const { maxValue=null, maxDates, minValue=null, minDates } = dataMinMax[d.siteID] || {}

		return <Grid item xs={3} key={idx}>
			<PriceEvolutionBaseWidget
				title={<LabelCountry label={d.retailer} country={d.country} />}
				currentValue={value}
				current={isPercentage ? formatPercentage(value) : priceEvolutionWidgetFormatPrice(value, d.currency)}
				prevValue={prevValue}
				previous={isPercentage ? formatPercentage(prevValue) : priceEvolutionWidgetFormatPrice(prevValue, d.currency)}
				isPercentage={isPercentage}
				maxValue={disableMinMax ? null : formatPercentage(maxValue)}
				maxDates={maxDates}
				minValue={disableMinMax ? null : formatPercentage(minValue)}
				minDates={minDates}
				lowerMin={minValue === dataMinMax.higherMin}
				reverse={isPercentage}
				numVariants={numVariants}
				{...props}
			/>
		</Grid>
	})
}